import React, { useEffect, useState, useRef } from 'react';
import { getToken } from '../../services/Login';
import {isLocalhost} from '../../utils/Common';
let LOGIN_URL = `http://auth.tmrmetal.com/auth/oauth/authorize?response_type=code&client_id=ecm&redirect_uri=http://order.tmrmetal.com/login`;
if (isLocalhost) {
  LOGIN_URL = `http://auth.tmrmetal.com/auth/oauth/authorize?response_type=code&client_id=ecm&redirect_uri=http://localhost/login`;
}
export default React.forwardRef((props, ref) => {
  const { search } = props.location;
  const paramsString = search.substring(1)
  const searchParams = new URLSearchParams(paramsString)
  const code = searchParams.get('code');
  const initUrl = searchParams.get('initUrl');

  useEffect(() => {
    if (initUrl !== '' && code === null) {
      window.sessionStorage.setItem('initUrl', initUrl);
      window.location.href = LOGIN_URL;
    }
    if (code) {
      const url = window.sessionStorage.getItem('initUrl');
      window.sessionStorage.removeItem('initUrl');
      getToken(code).then(data => {
        window.location.href = url;
      }).catch(error => {
        //alert(error)
      })
    }
  }, [])

  return null;
}); 
